export default "__VITE_ASSET__FqYXASoo__"